import React from "react";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import Avatar from "../../system/components/avatar";
import {useTranslate} from "../../system/useTranslate";

export default function UserProfile() {
    const {id} = useParams();
    const translate = useTranslate();
    const workspace = useSelector((state) => state.app.workspaceMembershipData?.workspace);
    const membership = (workspace?.workspace_memberships || []).find((item) => [item?.member?.documentId, item?.member?.id, item?.documentId, item?.id].filter(Boolean).map(String).includes(String(id)));
    const member = membership?.member;
    if (!member) return <div className="p-5 text-center text-500">{translate("member-not-found")}</div>;
    return <div className="h-full overflow-auto p-4"><div className="surface-card border-1 border-200 border-round-2xl p-5 flex flex-column align-items-center gap-3"><Avatar memberData={member} size="xlarge"/><h1 className="m-0 text-xl">{member.fullname || member.username}</h1><span className="text-sm text-500">{member.jobPosition || member.email || ""}</span><span className="text-xs text-500">{membership.memberShipStatus}</span></div></div>;
}
